<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">
                <!-- <img
      src="../../../assets/images/service/neurologie-1.jpg"
      alt="Neurologie"
    /> -->

                <h2>Neurologie – grijă pentru sănătatea sistemului nervos</h2>
                <p>
                  Neurologia se ocupă cu diagnosticarea și tratamentul afecțiunilor
                  sistemului nervos central și periferic, având un rol esențial în
                  menținerea funcțiilor motorii, cognitive și senzoriale.
                </p>

                <!-- <h2>Echipa medicală</h2> -->
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/raluca_roman#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/team/member-3.jpg"
                            alt="dr-gina-neculaes"></div>
                        <div class="team-info">
                          <span>Dr. Raluca Roman</span>
                          <!-- <span>Medic specialist neurolog</span> -->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>



                <h3>Servicii și evaluări disponibile</h3>
                <p>
                  În cadrul cabinetului de neurologie sunt oferite evaluări medicale
                  complete pentru principalele afecțiuni ale sistemului nervos.
                </p>

                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">
                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i class="ri-check-double-line" style="vertical-align: bottom;"></i> {{ service.name }}
                    </div>
                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>
                  </div>
                </div>
                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>
                <h3>Întrebări frecvente</h3>
                <p>
                  Mai jos găsești răspunsuri la cele mai frecvente întrebări legate de
                  consultațiile neurologice.
                </p>

                <div class="accordion" id="accordionExample_one">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Când este recomandată o consultație neurologică?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Consultația neurologică este recomandată în cazul durerilor de cap
                          persistente, amețelilor, tulburărilor de memorie, amorțelilor,
                          slăbiciunii musculare sau problemelor de coordonare.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Este necesară trimitere pentru consultație?
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Pentru consultațiile în cadrul clinicii private, nu este necesară
                          trimitere medicală. Programarea se poate face direct.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Ce investigații pot fi recomandate?
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          În funcție de simptomatologie, medicul poate recomanda investigații
                          suplimentare, precum imagistică sau teste funcționale, pentru un
                          diagnostic corect.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Pot veni la consultație pentru un control preventiv?
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Da, consultația neurologică este recomandată și în scop preventiv,
                          în special în cazul antecedentelor neurologice sau simptomelor
                          recurente.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "NeurologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
      services: [
        {
          name: "Consultație neurologică",
          price: 300
        },
        {
          name: "Evaluare clinică neurologică detaliată",
          price: 200
        },
        {
          name: "Interpretare investigații neurologice",
          price: 350
        },
        {
          name: "Monitorizarea evoluției și ajustarea tratamentului",
          price: 200
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>